<template>
  <div>
    <PageName title="Настройки" />
    <Preloader v-if="false /*mailLoading*/" />
    <Form :value="settingsData" v-else @request="setSettings" class="settings">
      <div class="settings-form">
        <h3 style="margin-bottom: 20px">Настройка почты</h3>

        <div class="form-block" style="margin-bottom: 20px">
          <VInput name="host" required placeholder="Хост" />
          <VInput name="port" required placeholder="Порт" />

          <VInput name="username" required placeholder="Логин" />

          <VInput
            name="from_address"
            required
            email
            placeholder="Электронная почта отправителя"
          />

          <VInput
            name="password"
            type="password"
            required
            placeholder="Пароль от почты"
          />
          <VInput v-show="false" name="id" />

          <VSelect
            required
            name="encryption"
            placeholder="Шифрование"
            :items="['Без шифрования', 'ssl', 'tls']"
          />
        </div>

        <h3 style="margin-bottom: 20px">Параметры авторизации</h3>

        <div class="form-block">
          <VInput name="length" required placeholder="Длина пароля" />

          <VInput
            name="days_to_update"
            required
            placeholder="Частота смены пароля (дней)"
          />
        </div>

        <span>
          <p class="input__label" style="margin-bottom: 12px; margin-top: 20px">
            Пароль должен содержать:
          </p>
          <div class="form-block">
            <Checkbox
              name="uppercase"
              label="Заглавные буквы (A-Z)"
              class="form__checkbox"
            />
            <Checkbox
              name="lowercase"
              label="Строчные буквы (a-z)"
              class="form__checkbox"
            />
            <Checkbox
              name="numbers"
              label="Цифры (0-9)"
              class="form__checkbox"
            />
            <Checkbox
              name="symbols"
              label="Символы (!, #, %)"
              class="form__checkbox"
            />
          </div>
        </span>
      </div>

      <div>
        <Button
          :loading="saveLoading"
          width="228px"
          height="48px"
          text="Сохранить"
          class="btn-primary"
        />
        <Button
          @click.native.prevent="$router.go(-1)"
          width="228px"
          height="48px"
          text="Отменить"
          class="btn-secondary"
          style="margin-top: 12px"
        />
        <Button
          @click.native.prevent="sendMailAction"
          width="228px"
          height="48px"
          text="Отправить тестовое письмо"
          class="btn-outline-primary"
          style="margin-top: 32px; padding: 0 40px"
        />
      </div>
    </Form>
  </div>
</template>

<script>
import Form from "@/components/Form/Form.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import VSelect from "@/components/Form/VSelect.vue";
import Checkbox from "@/components/Form/Checkbox.vue";
import Button from "@/components/Button.vue";
import PageName from "@/components/PageName.vue";
import Preloader from "@/components/Preloader.vue";
import { mapState } from "vuex";
import { getSettings, setSettings, sendMail } from "@/api/settings";

export default {
  name: "Settings",
  components: {
    PageName,
    Form,
    VInput,
    Button,
    Preloader,
    VSelect,
    Checkbox,
  },
  mounted() {
    getSettings().then((res) => {
      this.settingsData = this.convertToObject(res);
    });
  },
  data() {
    return {
      saveLoading: false,
      settingsData: {},
      mailLoading: true,
    };
  },
  computed: {
    ...mapState("users", ["activeUser"]),
  },
  methods: {
    convertBoll(data) {
      if (data === true) return "1";
      else if (data === false) return "0";
      else if (data === "1") return true;
      else return false;
    },

    convertToObject(array) {
      let object = {};
      array.map((item) => (object[item.name] = item.value));
      object.uppercase = this.convertBoll(object.uppercase);
      object.lowercase = this.convertBoll(object.lowercase);
      object.numbers = this.convertBoll(object.numbers);
      object.symbols = this.convertBoll(object.symbols);
      if (object.encryption === null) object.encryption = "Без шифрования";
      return object;
    },

    convertToArray(data, type) {
      return Object.entries(data).map(([key, value]) => {
        return {
          section: type,
          name: key,
          value: value,
        };
      });
    },

    async setSettings(data) {
      const {
        host,
        port,
        username,
        password,
        length,
        days_to_update,
        from_address,
      } = data;
      let encryption = data.encryption;
      if (data.encryption === "Без шифрования") encryption = null;
      const mail = {
        host,
        port,
        username,
        encryption,
        password,
        from_address,
      };
      const authorization = {
        length,
        days_to_update,
        uppercase: this.convertBoll(data.uppercase),
        lowercase: this.convertBoll(data.lowercase),
        numbers: this.convertBoll(data.numbers),
        symbols: this.convertBoll(data.symbols),
      };
      const mailArray = this.convertToArray(mail, "mail");
      const authorizationArray = this.convertToArray(authorization, "password");
      const settingsData = [...mailArray, ...authorizationArray];

      try {
        const res = await setSettings(settingsData);
        this.settingsData = this.convertToObject(res);
        this.$root.popup("Настройки сохранены", null, "success");
      } catch (err) {
        Promise.reject(err);
      }
    },
    async sendMailAction() {
      try {
        await sendMail();
        this.$root.popup("Письмо отправлено", null, "success");
      } catch (err) {
        Promise.reject(err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.settings {
  flex-direction: row;
  gap: 15px;
  margin-top: 32px;

  @media screen and (max-width: 1500px) {
    margin-top: 24px;
  }

  .settings-form {
    padding: 48px 40px;
    background: $light-gray;
    border-radius: 4px;
    width: 100%;

    @media screen and (max-width: 1500px) {
      padding: 32px 30px;
    }
  }

  .form-block {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 33px;
    row-gap: 12px;

    @media screen and (max-width: 1500px) {
      column-gap: 18px;
      row-gap: 8px;
    }
  }
}
</style>
